import React from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

const UnitCountOne = ({ dashboardData }) => {
  console.log("dashboardData", dashboardData);
  const navigate = useNavigate();
  return (
    <>
      <div className="row row-cols-xxxl-7 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-1 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/user`)}
              style={{ cursor: "pointer" }} // shows pointer on hover
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Users
                  </p>
                  <h6 className="mb-0">{dashboardData.totalUsers}</h6>
                </div>
                <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="gridicons:multiple-users"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/host`)}
              style={{ cursor: "pointer" }} // shows pointer on hover
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Hosts
                  </p>
                  <h6 className="mb-0">{dashboardData.totalHosts}</h6>
                </div>
                <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="gridicons:multiple-users"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/club?type=Club`)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Clubs
                  </p>
                  <h6 className="mb-0">{dashboardData.totalclubs}</h6>
                </div>
                <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:office-building-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/club?type=Booth`)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Booth
                  </p>
                  <h6 className="mb-0">{dashboardData.totalbooth}</h6>
                </div>
                <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:office-building-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col">
          <div className="card shadow-none border bg-gradient-start-1 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/club?type=Event`)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Events
                  </p>
                  <h6 className="mb-0">{dashboardData.totalevents}</h6>
                </div>
                <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:office-building-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/club?type=VIP Entry`)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total VIP Entry
                  </p>
                  <h6 className="mb-0">{dashboardData.totalVIP}</h6>
                </div>
                <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:office-building-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
                <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <div
              className="card-body p-20"
              onClick={() => navigate(`/club?type=Table`)}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Tables
                  </p>
                  <h6 className="mb-0">{dashboardData.totalTable}</h6>
                </div>
                <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:office-building-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnitCountOne;
